import { useContentLoading } from '../contexts/ContentLoadingContext';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useApiLoader = () => {
  const { showContentLoader, hideContentLoader } = useContentLoading();
  const location = useLocation();
  const navigationTimerRef = useRef<boolean>(false);

  // Track navigation state to avoid double loaders
  useEffect(() => {
    navigationTimerRef.current = true;
    const timer = setTimeout(() => {
      navigationTimerRef.current = false;
    }, 1000); // Match NavigationWrapper timing

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const withLoader = async <T,>(
    apiCall: () => Promise<T>,
    loadingText: string = 'Loading...'
  ): Promise<T> => {
    try {
      // Only show API loader if not in navigation mode
      if (!navigationTimerRef.current) {
        showContentLoader(loadingText);
      }
      const result = await apiCall();
      return result;
    } finally {
      // Add a small delay to ensure smooth UX
      setTimeout(() => {
        hideContentLoader();
      }, 300);
    }
  };

  return { withLoader, showContentLoader, hideContentLoader };
};